import React, { ReactNode } from 'react';

import loadStripe from 'utils/loadStripe';

type Props = {
  render: (arg0: boolean) => ReactNode;
};
type State = {
  loading: boolean;
};

class StripeLoader extends React.Component<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    loading: true,
  };

  componentDidMount() {
    loadStripe().then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.render(this.state.loading);
  }
}

export default StripeLoader;
